import useApi from "./useApiRequest";
import { useMutation, useQuery } from "react-query";

export const GetAllUsers = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.get(`/usuarios?limit=${params.limit}&paginationToken=${params.paginationToken || ''}`);
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        getAllUsersMutation: mutation.mutate,
    };
}

export const GetUsersPaginated = (limit = 20, paginationToken = '') => {
  const api = useApi();
  return useQuery(['recover_users', limit, paginationToken], async () => {
    const { data } = await api.get(`/usuarios?limit=${limit}&paginationToken=${paginationToken || ''}`);
    return data;
  }, {
    refetchOnWindowFocus: false,
    retry: false,
    enabled: !!limit,
  });
}